
import React from 'react';
import Select from 'react-select';
import { Row, Col, Label, Input, Button } from 'reactstrap';
import { almas } from '../../constant/globalConstantsTypeClients';
import "../../components/users/modalCard.css";

export const FormCard = (props) => {

    const {
        section,
        card_code,
        handleInputChange,
        handleCheckChange,
        listDepartament,
        handleSelectValues,
        id_departaments,
        url_helen,
        name_user,
        generateCardCode,
        validationsCard,
        savedCardCode, 
        handleCardCodeChange,
        handleToggleAllSections
    } = props;

    const validName =
        typeof name_user === "string" &&
        name_user.trim().length > 0;

    const userInitial = validName
        ? name_user.trim().charAt(0).toUpperCase()
        : null;

    const sections = Array.isArray(section) ? section : [];

    const selectedSections = sections.filter(
        item => item.checkSection
    ).length;

    const hasValidCardCode = /^\d{4}$/.test(
        String(card_code ?? "").trim()
    );

    const allSectionsSelected =
        sections.length > 0 &&
        selectedSections === sections.length;

    return (
        <Col sm="12" className="p-l-0 p-r-0">

            <div className="form-section form-section-modern">
                <Row className="gx-3 gy-2 align-items-center">
                    <Col xs="12" lg="4">
                        <div className="user-header user-header-modern">
                            <div className="user-header-content">

                                <div className="user-avatar">
                                    {userInitial ? (
                                        <span>{userInitial}</span>
                                    ) : (
                                        <i className="fa fa-user-o"></i>
                                    )}
                                </div>

                                <div className="user-info">

                                    <div className="user-name">
                                        {validName
                                            ? name_user
                                            : "Usuario"}
                                    </div>

                                    <div className="user-subtitle">
                                        Configuración de toma de muestra y asignación de seccionesss
                                    </div>

                                    {!savedCardCode?.trim() && (
                                        <div className="card-traceability-warning">
                                            <i className="fa fa-exclamation-circle"></i>
                                            <span>
                                                La tarjeta de trazabilidad aún no ha sido creada.
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col xs="12" lg="8">
                        <div className="card-access-panel card-access-modern">
                            <div className="card-access-header card-access-header-modern">
                                <i className="fa fa-shield"></i>

                                <h6>
                                    Acceso a toma de muestras
                                </h6>

                                <div className="card-access-header-line"></div>
                            </div>

                            <Row className="gx-3 gy-2">
                                <Col xs="12" md="6">
                                   <Label className="label-custom">
                                        {url_helen === almas
                                            ? "Acceso de autorización a muestreo"
                                            : "Código de acceso"}

                                        <span className="text-muted ms-1">
                                            (Opcional)
                                        </span>
                                    </Label>

                                    <div className="card-code-container">
                                        <div
                                            className={`card-code-field ${
                                                validationsCard?.card_code
                                                    ? "card-field-error"
                                                    : ""
                                            }`}
                                        >

                                            <i className="fa fa-hashtag card-code-icon"></i>

                                            <Input
                                                type="text"
                                                autoComplete="off"
                                                className="card-code-input"
                                                name="card_code"
                                                value={card_code || ""}
                                                onChange={handleCardCodeChange}
                                                maxLength={4}
                                                placeholder="0000"
                                                aria-invalid={!!validationsCard?.card_code}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>

                                        <Button
                                            type="button"
                                            className="card-code-generate"
                                            onClick={generateCardCode}
                                            title={
                                                card_code
                                                    ? "Generar otro código"
                                                    : "Generar código aleatorio"
                                            }
                                        >
                                            <i className="fa fa-refresh"></i>
                                            <span>Generar</span>
                                        </Button>
                                    </div>

                                    {validationsCard?.card_code && (
                                        <small className="card-validation-error">
                                            <i className="fa fa-exclamation-circle"></i>
                                            Debes ingresar un código de 4 dígitos.
                                        </small>
                                    )}

                                </Col>

                                {/* DEPARTAMENTO */}
                                <Col xs="12" md="6">
                                    <Label className="label-custom">
                                        Departamento
                                        {hasValidCardCode && (
                                            <span className="text-danger ms-1">*</span>
                                        )}
                                    </Label>
                                    
                                        <Select
                                            isMulti
                                            name="id_departaments"
                                            value={hasValidCardCode ? (id_departaments || []) : []}
                                            onChange={(e) =>
                                                handleSelectValues(e, "id_departaments")
                                            }
                                            options={listDepartament || []}
                                            placeholder={
                                                hasValidCardCode
                                                    ? "Selecciona uno o varios"
                                                    : "Primero ingresa un código"
                                            }
                                            noOptionsMessage={() => "Sin opciones"}
                                            isSearchable
                                            isDisabled={!hasValidCardCode}
                                            classNamePrefix="select"
                                            className={`card-department-select ${
                                                validationsCard?.id_departaments
                                                    ? "card-select-error"
                                                    : ""
                                            }`}
                                        />

                                    {validationsCard?.id_departaments && (
                                        <small className="card-validation-error">
                                            <i className="fa fa-exclamation-circle"></i>
                                            Debes seleccionar al menos un departamento.
                                        </small>
                                    )}

                                </Col>
                            </Row>
                        </div>
                    </Col>

                </Row>

            </div>

            {/* ÁREAS Y SECCIONES */}
            <div className="card-sections-container">
                <div className="card-sections-header">
                    <div className="card-sections-title">
                        <div className="card-sections-icon">
                            <i className="fa fa-th-large"></i>
                        </div>

                        <div>
                            <h6>Áreas y secciones</h6>
                            <p>
                                Selecciona las secciones a las que
                                tendrá acceso el usuario.
                            </p>
                        </div>

                    </div>

                    <div className="card-sections-actions">

                        <div className="card-sections-counter">
                            <i className="fa fa-check-circle"></i>
                            {selectedSections} de {sections.length} activas
                        </div>

                        <Button
                            type="button"
                            className={`card-select-all-btn ${
                                allSectionsSelected ? "is-selected" : ""
                            }`}
                            onClick={handleToggleAllSections}
                            disabled={sections.length === 0}
                            title={
                                allSectionsSelected
                                    ? "Desactivar todas las secciones"
                                    : "Activar todas las secciones"
                            }
                        >
                            <i
                                className={
                                    allSectionsSelected
                                        ? "fa fa-times-circle"
                                        : "fa fa-check-square-o"
                                }
                            ></i>

                            <span>
                                {allSectionsSelected
                                    ? "Deseleccionar todas"
                                    : "Seleccionar/ Quitar todos"}
                            </span>
                        </Button>
                    </div>
                </div>

                <Row className="sections-grid">
                    {sections.map(element => (
                        <Col xs="6" sm="4" md="3" lg="2" key={element.id_section} className="section-column">
                            <div className="section-box">
                                <Label className="switch mb-2">
                                    <Input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={!!element.checkSection}
                                        onChange={(e) =>
                                            handleCheckChange(
                                                e,
                                                element.id_section
                                            )
                                        }
                                    />
                                    <span className="slider round"></span>
                                </Label>

                                <span className="section-text">
                                    {element.name}
                                </span>
                            </div>
                        </Col>
                    ))}
                </Row>
                {sections.length === 0 && (
                    <div className="card-sections-empty">
                        <i className="fa fa-folder-open-o"></i>
                        <span>No hay secciones disponibles.</span>
                    </div>
                )}
            </div>
        </Col>
    );
};
